import { PropertyType } from '../../../common';

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	email: data.email,
	two_step_code: data.two_step_code,
});
